import ShelfShowView from '@shared/shelves/ShelfShowView'
import { useLoaderData } from 'react-router-dom'
import { useOperatorData } from '@contexts/operator/OperatorDataContext'

import { shelfService } from '@services/operator/shelfService'

export default function OperatorShelfShow() {
  const shelf = useLoaderData()
  const operatorData = useOperatorData()

  return (
    <ShelfShowView
      shelf={shelf}
      role="operator"
      shelfService={shelfService}
      shelfTypes={operatorData?.shelfTypes || []}
    />
  )
}
